// * Redux imports
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import AppStateReducer from './Slice/AppStateSlice';
import CommonReducer from "./Slice/CommonSlice";
import UserDataReducer from './Slice/LoginSlice';
import headerSliceReducer from "./Slice/headerSlice";
import rightDrawerSliceReducer from "./Slice/rightDrawerSlice";
import modalSliceReducer from "./Slice/modalSlice";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import persistStore from "redux-persist/es/persistStore";
import thunk from "redux-thunk";

const persistConfig = {
    key: "Avita",
    storage,
};

const rootReducer = combineReducers({
    auth: UserDataReducer,
    AppState: AppStateReducer,
    common: CommonReducer,
    header: headerSliceReducer,
    rightDrawer: rightDrawerSliceReducer,
    modal: modalSliceReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
    reducer: persistedReducer,
    middleware: [thunk],
    devTools: process.env.NODE_ENV !== "production",
});

const persistor = persistStore(store);

export { store, persistor };
